import React from 'react';

import { telemetryClickHandler } from '../telemetryHandler';
import type { NavLink } from '../types';

interface SingleColumnMenuProps {
  links: NavLink[];
}

export default function SingleColumnMenu({
  links,
}: SingleColumnMenuProps): JSX.Element {
  return (
    <div className="flex flex-col gap-6 whitespace-nowrap p-8 rounded-2xl">
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          className="text-base font-semibold text-gray-900 hover:opacity-80"
          onClick={telemetryClickHandler(link.clickEvent)}
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}
